import React from 'react';

const FormatTitle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.1665 3.33333V5.83333H8.74984V15.8333H11.2498V5.83333H15.8332V3.33333H4.1665Z" />
  </svg>
);

export default FormatTitle;
